import { IsNotEmpty, IsNumber, IsNumberString, IsString, Length } from 'class-validator';
import { DownloadFileDto } from './download-file.dto';

export class CreateSignerDto {
  @IsNumber()
    legalEntityId: number;

  @IsString()
  @IsNotEmpty({ message: 'Не должно быть пустым' })
    titleForm1: string = '';

  @IsString()
    titleForm2: string = '';

  @IsString()
    titleForm3: string = '';

  @IsString()
    positionForm1: string = '';

  @IsString()
    positionForm2: string = '';

  @IsString()
    positionForm3: string = '';

  @IsString()
    basedOn: string = '';

  signature: DownloadFileDto | null;
}

export class SignerDto extends CreateSignerDto {
  id: number;
}

export class UpdateSignerDto extends CreateSignerDto {
  id: number;
}
